export const MAIN_MENU_WIDTH = {
  OPEN: 200,
  COLLAPSED: 60
}

export const SUB_MENU_WIDTH = {
  DEFAULT: 170,
  COLLAPSED: 50,
  MIN: 170,
  MAX: 340
}

const SIDEBAR_STORE = 'micro/sidebar/UPDATE_STATE'

export default {
  data() {
    return {
      subMenuResizeStartX: 0,
      subMenuResizeStartWidth: SUB_MENU_WIDTH.DEFAULT,
      subMenuResizeFrameId: null,
      subMenuResizePendingWidth: SUB_MENU_WIDTH.DEFAULT
    }
  },
  computed: {
    sidebarState() {
      return this.$store?.state?.micro?.sidebar || {}
    },
    subMenuWidth() {
      return this.sidebarState.subMenuWidth || SUB_MENU_WIDTH.DEFAULT
    },
    subMenuPendingWidth() {
      return (
        this.sidebarState.subMenuPendingWidth ||
        this.sidebarState.subMenuWidth ||
        SUB_MENU_WIDTH.DEFAULT
      )
    },
    subMenuResizing() {
      return !!this.sidebarState.subMenuResizing
    },
    canResizeSubMenu() {
      const browserPath = window.location?.pathname || ''
      const routePath = this.$route?.path || ''
      return (
        browserPath.indexOf('/service/publish') >= 0 ||
        routePath.indexOf('/channelManage') >= 0
      )
    },
    currentSubMenuWidth() {
      if (this.SUBISCOLLAPSE) return SUB_MENU_WIDTH.COLLAPSED
      if (!this.canResizeSubMenu) return SUB_MENU_WIDTH.DEFAULT
      return this.subMenuResizing ? this.subMenuPendingWidth : this.subMenuWidth
    },
    menuContainerStyle() {
      return {
        '--sub-menu-width': `${this.currentSubMenuWidth}px`
      }
    }
  },
  beforeDestroy() {
    this.stopSubMenuResize()
  },
  methods: {
    updateSidebarState(name, data) {
      this.$store.commit(SIDEBAR_STORE, { name, data })
    },
    clampSubMenuWidth(width) {
      return Math.min(SUB_MENU_WIDTH.MAX, Math.max(SUB_MENU_WIDTH.MIN, width))
    },
    startSubMenuResize(e) {
      if (this.SUBISCOLLAPSE || !this.canResizeSubMenu) return
      e.preventDefault()
      e.stopPropagation()
      this.subMenuResizeStartX = e.clientX
      this.subMenuResizeStartWidth = this.subMenuWidth
      this.subMenuResizePendingWidth = this.subMenuWidth
      this.updateSidebarState('subMenuResizing', true)
      document.addEventListener('mousemove', this.onSubMenuResizing)
      document.addEventListener('mouseup', this.stopSubMenuResize)
    },
    onSubMenuResizing(e) {
      if (!this.subMenuResizing) return
      const nextWidth =
        this.subMenuResizeStartWidth + e.clientX - this.subMenuResizeStartX
      this.subMenuResizePendingWidth = this.clampSubMenuWidth(nextWidth)
      if (this.subMenuResizeFrameId) return

      this.subMenuResizeFrameId = window.requestAnimationFrame(() => {
        this.updateSidebarState(
          'subMenuPendingWidth',
          this.subMenuResizePendingWidth
        )
        this.subMenuResizeFrameId = null
      })
    },
    stopSubMenuResize() {
      document.removeEventListener('mousemove', this.onSubMenuResizing)
      document.removeEventListener('mouseup', this.stopSubMenuResize)
      if (this.subMenuResizeFrameId) {
        window.cancelAnimationFrame(this.subMenuResizeFrameId)
        this.subMenuResizeFrameId = null
      }
      if (!this.subMenuResizing) return
      this.updateSidebarState('subMenuWidth', this.subMenuResizePendingWidth)
      this.updateSidebarState(
        'subMenuPendingWidth',
        this.subMenuResizePendingWidth
      )
      this.updateSidebarState('subMenuResizing', false)
    }
  }
}
